import {RDX_SESSION_UPDATE, RDX_SESSION_INIT, RDX_SESSION_INIT_DONE, RDX_SESSION_LOCALE_UPDATE} from './sessionAction';

const initial = {
	locale: 'en_US',
	localeIntl: 'en-US',
	sessionId : 'NA'
};

const session = (state = initial, action) => {
	let newState = Object.assign({}, state);
	switch (action.type) {
		case RDX_SESSION_UPDATE :
			newState = Object.assign({}, newState, action.jsonO);
			return newState;
		case RDX_SESSION_INIT :
			return state;
		case RDX_SESSION_INIT_DONE:
			return state;
		case RDX_SESSION_LOCALE_UPDATE:
			newState.localeIntl = action.localeIntl;
			newState.locale = newState.localeIntl.replace('-', '_');
			return newState;
		default:
			return state;
	}
};

export default session;